export function displayDebugInfo(elements, topScrollLimit, selectedId) {
  if (!elements) {
    return;
  }

  elements.forEach((element) => {
    // eslint-disable-next-line no-param-reassign
    element.style.border = '4px dotted blue';
  });

  const DEBUG_LINE_ID = 'debug_line_active_element';

  if (!document.getElementById(DEBUG_LINE_ID)) {
    const debugLineElement = document.createElement('div');
    debugLineElement.id = DEBUG_LINE_ID;
    debugLineElement.style.borderBottom = '1px solid red';
    debugLineElement.style.height = '1px';
    debugLineElement.style.position = 'fixed';
    debugLineElement.style.left = 0;
    debugLineElement.style.top = `${topScrollLimit}px`;
    debugLineElement.style.width = '100%';
    debugLineElement.style.zIndex = 99;
    document.body.appendChild(debugLineElement);
  }

  const DEBUG_TEXT_ID = 'debug_text_active_element';
  let debugIdElement = document.getElementById(DEBUG_TEXT_ID);

  if (!debugIdElement) {
    debugIdElement = document.createElement('div');
    debugIdElement.id = DEBUG_TEXT_ID;
    debugIdElement.style.top = `${topScrollLimit + 3}px`;
    debugIdElement.style.position = 'fixed';
    debugIdElement.style.zIndex = 99;
    debugIdElement.style.right = 0;
    debugIdElement.style.background = 'white';
    debugIdElement.style.padding = '5px';
    document.body.appendChild(debugIdElement);
  }

  debugIdElement.innerText = selectedId;
}

export const highliteElement = (elements, highlitedElement) => {
  if (!elements) {
    return;
  }

  elements.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.opacity = 0.3;
  });

  // eslint-disable-next-line no-param-reassign
  highlitedElement.style.opacity = 1;
};
